export const cities_data = [
  {
    key: "1",
    cityName: "Los Angeles",
    stateName: "California",
    countryName: "United States",
    status: "Active",
  },
  {
    key: "2",
    cityName: "New York City",
    stateName: "New York",
    countryName: "United States",
    status: "Active",
  },
  {
    key: "3",
    cityName: "Houston",
    stateName: "Texas",
    countryName: "United States",
    status: "Active",
  },
  {
    key: "4",
    cityName: "Munich",
    stateName: "Bavaria",
    countryName: "Germany",
    status: "Active",
  },
  {
    key: "5",
    cityName: "Montreal",
    stateName: "Quebec",
    countryName: "Canada",
    status: "Active",
  },
  {
    key: "6",
    cityName: "Toronto",
    stateName: "Ontario",
    countryName: "Canada",
    status: "Active",
  },
  {
    key: "7",
    cityName: "Miami",
    stateName: "Florida",
    countryName: "United States",
    status: "Active",
  },
  {
    key: "8",
    cityName: "Calgary",
    stateName: "Berlin",
    countryName: "Germany",
    status: "Active",
  },
  {
    key: "9",
    cityName: "Melbourne",
    stateName: "Victoria",
    countryName: "Australia",
    status: "Active",
  },
  {
    key: "10",
    cityName: "Johannesburg",
    stateName: "Gauteng",
    countryName: "Egypt",
    status: "Active",
  },
];
